import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from './api';

const ApiContext = createContext<ApiClient | null>(null);

/**
 * Injects the ApiClient into the tree. In production we pass the real
 * HttpApiClient; tests pass a fake implementing the same interface, so no live
 * backend (or network) is required.
 */
export function ApiProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}): JSX.Element {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) {
    throw new Error('useApi must be used within an <ApiProvider>');
  }
  return client;
}
